import gqlClient from 'Utils/graphql-client/graphqlClient';
import { STATE_PRODUCT_ALL_INCLUSIVE_SERVICES } from 'Utils/request/requestDictionary';
import { buildArgs } from 'Utils/graphql';
export type AllInclusiveServicesCriteria = {
  accommodationId?: string;
  accommodationLabel?: string;
  includesChildcare?: boolean;
  includesTransportation?: boolean;
  productId: string;
};
export type AllInclusiveServicesData = Array<{
  description?: string;
  icon: string;
  label: string;
  type: string;
}>;
export const fetchAllInclusiveServices = (
  appContext: AppContext,
  criteria: AllInclusiveServicesCriteria,
): Promise<{
  fetchAllInclusiveServices: AllInclusiveServicesData;
}> => {
  const allInclusiveServicesArgs = buildArgs(criteria);
  const query = `query {
      allInclusiveServices(${allInclusiveServicesArgs}) {
        description
        icon
        label
        type
      }
    }
  `;
  return gqlClient.runQuery(query, appContext, {
    requestName: STATE_PRODUCT_ALL_INCLUSIVE_SERVICES,
  });
};
